import React, { useEffect, useState } from "react";
import { Route, useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import "./InternalLayout.scss";
import { CheckValue, checkRole, UniqueID } from "../../services/CommonFunction";

import Header from "../../components/Header/Header";
import Home from "../../containers/Home/Home";
import LiveAndUpcoming from "../../containers/LiveAndUpcoming/LiveAndUpcoming";
import { accessTokenApi } from "../../services/CallApi";
import { ErrorUI } from "../../components/UI/Modals/Modals";
import { profileActions } from "../../store";
import ClassInfo from "../../containers/ClassInfo/ClassInfo";
import Studios from "../../containers/Studios/Studios";
import OndemandScreen from "../../containers/OndemandScreen/OndemandScreen";
import CoachProfile from "../../containers/CoachProfile/CoachProfile";
import ClassSummary from "../../containers/ClassSummary/ClassSummary";
import PrivacySettings from "../../containers/PrivacySettings/PrivacySettings";
import MemberProfile from "../../containers/MemberProfile/MemberProfile";
import MyActivity from "../../containers/MyActivity/MyActivity";
import { getAppNameFromURL, staticVar } from "../../services/Constants";
const InternalLayout = (props) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    // console.log("location", location);
    // console.log("profileActions", props);
    localStorage.removeItem("workoutData");
    localStorage.removeItem("ondemandData");
    localStorage.removeItem("setVolume");
    staticVar.permission = false;
    if (location.pathname === "/") {
      history.push("/Home");
    } else {
      history.push(location.pathname);
    }
    // getAccessTokenLoginData();
  }, []);

  const getAccessTokenLoginData = () => {
    accessTokenApi().then(async (res) => {
      if (res.status) {
        dispatch(profileActions.updateProfileData(res.data));
      } else {
        ErrorUI(res.data, () => getAccessTokenLoginData());
      }
    });
  };

  const header = <Header {...props} />;
  return (
    <React.Fragment>
      {/* =================HEADER======================= */}
      {header}
      {/* =================Main Section=================== */}
      <main className="main">
        <section className="main_div">
          <div>
            <Route
              exact
              path="/Home"
              render={(props) => {
                return <Home {...props} />;
              }}
            />
            <Route
              exact
              path="/OndemandScreen"
              render={(props) => {
                return <OndemandScreen {...props} />;
              }}
            />
            <Route
              exact
              path="/LiveAndUpcoming"
              render={(props) => {
                return <LiveAndUpcoming {...props} />;
              }}
            />
            <Route
              exact
              path="/MyActivity"
              render={(props) => {
                return <MyActivity {...props} />;
              }}
            />
            {/* {getAppNameFromURL() === "tribe" ? ( */}
            <Route
              exact
              path="/Studios"
              render={(props) => {
                return <Studios {...props} />;
              }}
            />
            {/* ) : null} */}
            <Route
              exact
              path="/PrivacySettings"
              render={(props) => {
                return <PrivacySettings {...props} />;
              }}
            />
            <Route
              exact
              path="/MemberProfile"
              render={(props) => {
                return <MemberProfile {...props} />;
              }}
            />
            <Route
              exact
              path="/ClassSummary/:activityId/:userSessionId/:isOndemand"
              render={(props) => {
                return <ClassSummary {...props} />;
              }}
            />
            <Route
              exact
              path="/CoachProfile/:id?"
              render={(props) => {
                return <CoachProfile {...props} />;
              }}
            />
            <Route
              exact
              path="/Category/:id?"
              render={(props) => {
                return <CoachProfile {...props} isCategory={true} />;
              }}
            />
            <Route
              exact
              path="/ClassInfo/:parentId?/:id"
              render={(props) => {
                return <ClassInfo {...props} />;
              }}
            />
          </div>
        </section>
      </main>
    </React.Fragment>
  );
};

export default InternalLayout;
